import { SAvatar } from './styled';
import { TeamspaceAvatarProps } from './types';

export const TeamspaceAvatar = ({
  name,
  color = 'midnight',
  disabled = false,
  isActive = false,
  size = 'md',
}: TeamspaceAvatarProps) => {
  return (
    <SAvatar $color={color} $disabled={disabled} $isActive={isActive} $size={size} alt={name} variant="square">
      {name.charAt(0).toUpperCase()}
    </SAvatar>
  );
};
